module.exports = __webpack_public_path__ + "img/03.540a6ede.png";